import React, { useState } from 'react';
import { ArrowDown, ArrowUp } from 'lucide-react';
import { CARD, TH, TD, num, Avatar, TierBadge } from './caShared';

const COLS = [['handle', 'Creator Handle'], ['tier', 'Tier'], ['posts_tagged_in', 'Posts Tagged In'], ['total_engagement', 'Total Engagement'], ['in_vyvre_db', 'In Vyvre DB']];

export const CreatorAnalysisTab = ({ creators }) => {
  const [sort, setSort] = useState({ key: 'posts_tagged_in', dir: -1 });
  const rows = [...creators].sort((a, b) => {
    const x = a[sort.key], y = b[sort.key];
    return (typeof x === 'string' ? String(x).localeCompare(String(y)) : Number(x) - Number(y)) * sort.dir;
  });
  const click = (key) => setSort((s) => ({ key, dir: s.key === key ? -s.dir : (key === 'handle' || key === 'tier' ? 1 : -1) }));
  return (
    <div className={`${CARD} overflow-hidden`} data-testid="creator-analysis-tab">
      {!rows.length ? <div className="p-8 text-center text-sm text-[#6B7280]">No tagged creators in this period.</div> : (
        <table className="w-full" data-testid="creator-analysis-table">
          <thead><tr>{COLS.map(([k, h]) => (
            <th key={k} className={`${TH} cursor-pointer select-none`} onClick={() => click(k)} data-testid={`creator-sort-${k}`}>
              <span className="inline-flex items-center gap-1">{h}{sort.key === k && (sort.dir < 0 ? <ArrowDown size={12} /> : <ArrowUp size={12} />)}</span>
            </th>))}</tr></thead>
          <tbody>{rows.map((c) => (
            <tr key={c.handle} className="hover:bg-[#3B4FD8]/[0.03] transition-colors" data-testid={`creator-row-${c.handle}`}>
              <td className={TD}><a href={`https://www.instagram.com/${c.handle}/`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 font-medium hover:text-[#3B4FD8] transition-colors"><Avatar name={c.handle} size={30} />@{c.handle}</a></td>
              <td className={TD}><TierBadge tier={c.tier} /></td>
              <td className={`${TD} font-semibold`}>{c.posts_tagged_in}</td>
              <td className={TD}>{num(c.total_engagement)}</td>
              <td className={TD}>{c.in_vyvre_db
                ? <span className="rounded-full px-2.5 py-0.5 text-[11px] font-semibold bg-emerald-50 text-emerald-700" data-testid={`creator-indb-${c.handle}`}>Yes</span>
                : <span className="rounded-full px-2.5 py-0.5 text-[11px] font-semibold bg-gray-100 text-gray-500" data-testid={`creator-indb-${c.handle}`}>No</span>}</td>
            </tr>))}</tbody>
        </table>
      )}
    </div>
  );
};
